import { AvatarTitleCell, Checkbox, Stack, Table } from '@ui-components/neo.tax';
import React, { useCallback, useMemo } from 'react';
import { Column, CellProps } from 'react-table';

import { useCompanies } from '@neo.tax/shared/hooks';
import { GetCompaniesQueryCompany } from '@neo.tax/shared/hooks/useCompanies';

import { StyledTableContainer } from './member-scope-table.styled';

export const MemberScopeTable = ({
  disabled,
  onChangeSelectedCompanyIds,
  selectAll,
  selectedCompanyIds,
}: {
  selectedCompanyIds: string[];
  disabled?: boolean;
  selectAll?: boolean;
  onChangeSelectedCompanyIds: (companyIds: string[]) => void;
}): React.ReactElement => {
  const { companies } = useCompanies();

  const handleSelectCompany = useCallback(
    (companyId: string): void => {
      if (selectedCompanyIds.includes(companyId)) {
        onChangeSelectedCompanyIds(selectedCompanyIds.filter((id) => id !== companyId));
      } else {
        onChangeSelectedCompanyIds([...selectedCompanyIds, companyId]);
      }
    },
    [onChangeSelectedCompanyIds, selectedCompanyIds],
  );

  const columns: Array<Column<GetCompaniesQueryCompany>> = useMemo(
    () => [
      {
        id: 'company',
        Header: 'Company',
        width: 'minmax(0, 1fr)',
        accessor: 'shortName',
        Cell: ({ value }: React.PropsWithChildren<CellProps<GetCompaniesQueryCompany, string>>): JSX.Element => (
          <AvatarTitleCell title={value} size={6} fontSize="sm" fontWeight="normal" />
        ),
      },
      {
        id: 'access',
        Header: (): JSX.Element => (
          <Stack as="span" alignItems="center" justifyContent="center" fullWidth>
            Access
          </Stack>
        ),
        width: 136,
        accessor: 'id',
        Cell: ({ value }: React.PropsWithChildren<CellProps<GetCompaniesQueryCompany, string>>): JSX.Element => {
          const selected = selectedCompanyIds.includes(value);
          return (
            <Stack alignItems="center" justifyContent="center" fullWidth>
              <Checkbox
                id="checkbox"
                name="checkbox"
                disabled={disabled}
                checked={selectAll || selected}
                onChange={(): void => handleSelectCompany(value)}
              />
            </Stack>
          );
        },
      },
    ],
    [disabled, handleSelectCompany, selectAll, selectedCompanyIds],
  );

  return (
    <StyledTableContainer disabled={disabled}>
      <Table data={companies || []} columns={columns} />
    </StyledTableContainer>
  );
};
